import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Menu, { MenuItem } from 'material-ui/Menu';
import Table, {
    TableBody,
    TableCell,
    TableFooter,
    TableHead,
    TablePagination,
    TableRow,
    TableSortLabel,
} from 'material-ui/Table';
import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import Paper from 'material-ui/Paper';
import IconButton from 'material-ui/IconButton';
import Button from 'material-ui/Button';
import SettingsIcon from 'material-ui-icons/Settings';
import UserIcon from 'material-ui-icons/SupervisorAccount';
import Tooltip from 'material-ui/Tooltip';
import DeleteIcon from 'material-ui-icons/Delete';
import { lighten } from 'material-ui/styles/colorManipulator';
import { translate } from 'react-i18next';



class UsersTableHead extends React.Component {

    createSortHandler = property => event => {
        this.props.onRequestSort(event, property);
    };

    constructor(props) {
        super(props);

        let { t } = props;

        this.state = {
            columnData: [
                { id: 'name', paddingLeft: '10px', numeric: false, disablePadding: false, label: t('USER.FIRST_NAME') },
                { id: 'email', numeric: false, disablePadding: false, label: t('USER.EMAIL') },
                { id: 'jobTitle', numeric: false, disablePadding: false, label: t('USER.JOB_TITLE') },
                { id: 'userName', numeric: false, disablePadding: false, label: t('USER.USER_NAME') },
                { id: 'actions', numeric: false, disablePadding: false, label: t('BOOKINGS.ACTIONS'), width: '32px' }
            ]
        };
    }

    render() {
        const { order, orderBy, t } = this.props;
        return (
            <TableHead>
                <TableRow>
                    {this.state.columnData.map(column => {
                        return (
                            <TableCell
                                key={column.id}
                                numeric={column.numeric}
                                width={column.width}
                                style={{ width: column.width, backgroundColor: 'lightgrey', paddingLeft: column.paddingLeft }}
                                padding={'none'}
                                sortDirection={orderBy === column.id ? order : false}
                            >
                                <Tooltip
                                    title={t('USER.SORT')}
                                    placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                                    enterDelay={300}
                                >
                                    <TableSortLabel
                                        active={orderBy === column.id}
                                        direction={order}
                                        onClick={this.createSortHandler(column.id)}
                                    >
                                        {column.label}
                                    </TableSortLabel>
                                </Tooltip>
                            </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    }
}

UsersTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

const toolbarStyles = theme => ({
    root: {
        paddingRight: theme.spacing.unit,
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85),
            }
            : {
                color: theme.palette.text.secondary,
                backgroundColor: theme.palette.secondary.dark,
            },
    spacer: {
        flex: '1 1 100%',
    },
    actions: {
        color: theme.palette.text.secondary,
    },
    title: {
        flex: '0 0 auto',
    },
    tableTitle: {
        color: theme.palette.primary.main,
        fontSize: 24,
        fontWeight: 300
    }
});

let UsersTableToolbar = props => {
    const { numSelected, classes, anchorEl, t } = props;

    return (
        <Toolbar
            className={classNames(classes.root, {
                [classes.highlight]: numSelected > 0,
            })}
        >
            <div className={classes.title}>
                {numSelected > 0 ? (
                    <Typography color="inherit" variant="subheading">
                        {numSelected} selected
                    </Typography>
                ) : (
                    <Typography className={classes.tableTitle}>
                        <UserIcon style={{ width: 32, height: 32, float: 'left' }} />
                        <strong style={{ paddingLeft: 8 }}>{t('PAGE_TITLES.Users')}</strong>
                    </Typography>
                )}
            </div>
            <div className={classes.spacer} />
            <div className={classes.actions}>
                <Button aria-label="USER.ADD" variant="raised"
                    color="secondary"
                    aria-owns={anchorEl ? 'download-menu' : null}
                    style={{ minWidth: 180 }}
                    aria-haspopup="true"
                    onClick={(event) => {
                        if (props.actionhandler) {
                            props.actionhandler(null, 'ADD');
                        }
                    }}
                >
                    {t('USER.ADD')}
                    <icon>
                        <UserIcon />
                    </icon>
                </Button>
            </div>
            <div className={classes.actions}>
                {numSelected > 0 ? (
                    <Tooltip title="Delete">
                        <IconButton aria-label="Delete">
                            <DeleteIcon />
                        </IconButton>
                    </Tooltip>
                ) : (
                    <div>
                        {/*<IconButton aria-label="Descargar"
                aria-owns={anchorEl ? 'download-menu' : null}
                aria-haspopup="true"
                onClick={this.handleClick}>
                <DownloadPDF />
              </IconButton>
              */}
                    </div>
                )}
            </div>
        </Toolbar>
    );
};

UsersTableToolbar.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
};

UsersTableToolbar = translate('translations')(withStyles(toolbarStyles)(UsersTableToolbar));

/**
 * UsersTableMenu
 */
const menuStyles = theme => ({
    root: {
        backgroundColor: lighten(theme.palette.secondary.light, 0.85)
    }
});
class UsersTableMenu extends React.Component {
    handleClick = event => {
        this.setState({ anchorEl: event.currentTarget });
    };
    handleClose = () => {
        this.setState({ anchorEl: null });
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            anchorEl: null
        };
    }

    render() {
        const { options } = this.props;
        const { anchorEl } = this.state;
        return (
            <div>
                {options != undefined ? (<div>
                    <IconButton aria-label="More"
                        aria-owns={anchorEl ? 'long-menu' : null}
                        aria-haspopup="true" onClick={this.handleClick}>
                        <SettingsIcon />
                    </IconButton>
                    <Menu
                        id="long-menu"
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={this.handleClose}>
                        {options.map(option => (
                            <MenuItem key={option}
                                onClick={(event) => {
                                    if (this.props.actionhandler) {
                                        this.props.actionhandler(this.props.reservation, option);
                                    }
                                    this.handleClose();
                                }}>
                                {this.props.labels ? this.props.labels[option] : option}
                            </MenuItem>
                        ))}
                    </Menu></div>) : ''}
            </div>
        );
    }
}

/* eslint no-class-assign: warn */
UsersTableMenu = withStyles(menuStyles)(UsersTableMenu);

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
    },
    table: {
        minWidth: 800,
    },
    tableWrapper: {
        overflowX: 'auto',
    },
    invoiceLocator: {
        color: 'var(--primary-color)'
    }
});

class UsersTable extends React.Component {
    /**
     * Sort Table data.
     * @param {type} event
     * @param {String} property column id
     */
    handleRequestSort = (event, property) => {
        if (property === 'actions' || property === 'state') {
            return;
        }

        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        const data =
            this.props.data ?
                order === 'desc' ?
                    this.props.data.sort((a, b) => {
                        if (b.hasOwnProperty(orderBy) && a.hasOwnProperty(orderBy)) {
                            return (String(b[orderBy]).toUpperCase() < String(a[orderBy]).toUpperCase() ? -1 : 1);
                        } else {
                            return 1;
                        }
                    })
                    : this.props.data.sort((a, b) => {
                        if (b.hasOwnProperty(orderBy) && a.hasOwnProperty(orderBy)) {
                            return (String(a[orderBy]).toUpperCase() < String(b[orderBy]).toUpperCase() ? -1 : 1);
                        } else {
                            return 1;
                        }
                    })
                : [];

        this.setState({ data, order, orderBy });
    };
    handleSelectAllClick = (event, checked) => {
        if (checked) {
            this.setState({ selected: this.state.data.map(n => n.id) });
            return;
        }
        this.setState({ selected: [] });
    };
    handleClick = (event, id) => {
        const { selected } = this.state;
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        this.setState({ selected: newSelected });
    };
    handleChangePage = (event, page) => {
        this.setState({ page });
    };
    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };
    isSelected = id => this.state.selected.indexOf(id) !== -1;

    constructor(props, context) {
        super(props, context);
        this.state = {
            order: 'asc',
            orderBy: 'id',
            selected: [],
            data: [],
            page: 0,
            rowsPerPage: 10,
            anchorEl: null
        };
    }

    render() {
        const { classes, t } = this.props;

        const { order, orderBy, selected, rowsPerPage, page } = this.state;

        let length = 0 || this.props.data.length;
        const emptyRows = rowsPerPage - Math.min(rowsPerPage, length - page * rowsPerPage);

        return (
            <Paper className={classes.root}>
                <UsersTableToolbar
                    numSelected={selected.length}
                    actionhandler={this.props.actionhandler}
                />
                <div className={classes.tableWrapper}>
                    <Table className={classes.table}>
                        <UsersTableHead
                            numSelected={selected.length}
                            order={order}
                            orderBy={orderBy}
                            onSelectAllClick={this.handleSelectAllClick}
                            onRequestSort={this.handleRequestSort}
                            rowCount={this.props.data.length}
                            t={t}
                        />
                        <TableBody>
                            {this.props.data && this.props.data.length ?
                                this.props.data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(n => {
                                    const isSelected = this.isSelected(n.id);
                                    return (
                                        <TableRow
                                            hover
                                            /*onClick={event => this.handleClick(event, n.id)}*/
                                            aria-checked={isSelected}
                                            tabIndex={-1}
                                            key={n.id}
                                            selected={isSelected}>
                                            <TableCell padding={'none'} style={{ paddingLeft: '10px' }}>
                                                <a className={classes.invoiceLocator} href={'#/users'}
                                                    onClick={(event) => {
                                                        if (this.props.actionhandler) {
                                                            this.props.actionhandler(n, 'EDIT');
                                                        }
                                                    }}
                                                ><b>{n.name}</b></a>
                                            </TableCell>
                                            <TableCell padding={'none'}>{n.email}</TableCell>
                                            <TableCell padding={'none'}>{n.jobTitle}</TableCell>
                                            <TableCell padding={'none'}>{n.userName}</TableCell>
                                            <TableCell padding={'none'}>
                                                {this.props.allowedActions ?
                                                    <UsersTableMenu
                                                        options={this.props.allowedActions}
                                                        reservation={n}
                                                        actionhandler={this.props.actionhandler}
                                                        labels={this.props.menuactionslabels} />
                                                    : ''
                                                }
                                            </TableCell>
                                        </TableRow>
                                    );
                                })
                                :
                                emptyRows > 0 && (
                                    <TableRow style={{ height: 49 * emptyRows }}>
                                        <TableCell colSpan={6} />
                                    </TableRow>
                                )}
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    count={this.props.data.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    backIconButtonProps={{
                                        'aria-label': 'Previous Page',
                                    }}
                                    nextIconButtonProps={{
                                        'aria-label': 'Next Page',
                                    }}
                                    labelRowsPerPage={'Mostrando'}
                                    labelDisplayedRows={({ from, to, count }) => `${from} - ${to} de ${count}`}
                                    onChangePage={this.handleChangePage}
                                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>
                </div>
            </Paper>
        );
    }
}

UsersTable.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default translate('translations')(withStyles(styles)(UsersTable));


// WEBPACK FOOTER //
// ./src/components/User/UsersTable.js